import Footer from "./Footer"
import Header from "./Header"
import TopBar from "./TopBar"
import { useLocation } from "react-router-dom";

const Layout = ({children})=>{
    const location = useLocation();
    const isHome = location.pathname === "/";
    return(
        <div className={isHome ? "home-layout" : ""}>
            <TopBar /> 
            <Header />
            {children}
            <Footer />
        </div>
    )
}

export default Layout